import {
  IAppearanceConfig,
  MenuSectionConfig,
  SeoSettingsSectionConfig,
} from '@common/admin/appearance/types/appearance-editor-config';
import {message} from '@ui/i18n/message';
import {lazyAdminRoute} from '@common/admin/routes/lazy-admin-route';

export const AppAppearanceConfig: IAppearanceConfig = {
  preview: {
    // The public site (Blade) is what General, Themes, Menus and Custom code
    // change, so preview it by default.
    defaultRoute: '/',
    navigationRoutes: ['s', 'drive'],
  },
  sections: {
    'landing-page': {
      label: message('Landing Page'),
      position: 1,
      previewRoute: '/',
      routes: [
        {
          path: 'landing-page',
          lazy: () => lazyAdminRoute('LandingPageAppearanceForm'),
          children: [
            {
              index: true,
              lazy: () => lazyAdminRoute('LandingPageSectionGeneral'),
            },
            {
              path: 'action-buttons',
              lazy: () => lazyAdminRoute('LandingPageSectionActionButtons'),
            },
            {
              path: 'primary-features',
              lazy: () => lazyAdminRoute('LandingPageSectionPrimaryFeatures'),
            },
            {
              path: 'secondary-features',
              lazy: () => lazyAdminRoute('LandingPageSecondaryFeatures'),
            },
            {
              path: 'referral-section',
              lazy: () => lazyAdminRoute('LandingPageSectionReferral'),
            },
            {
              path: 'app-download',
              lazy: () => lazyAdminRoute('LandingPageSectionAppDownload'),
            },
            {
              path: 'footer',
              lazy: () => lazyAdminRoute('LandingPageSectionFooter'),
            },
          ],
        },
      ],
    },
    'pricing-page': {
      label: message('Pricing Page'),
      position: 1,
      previewRoute: '/pricing',
      routes: [
        {
          path: 'pricing-page',
          lazy: () => lazyAdminRoute('PricingPageAppearanceForm'),
          children: [
            {
              index: true,
              lazy: () => lazyAdminRoute('PricingPageSectionGeneral'),
            },
            {
              path: 'plans',
              lazy: () => lazyAdminRoute('PricingPageSectionPlans'),
            },
            {
              path: 'faq',
              lazy: () => lazyAdminRoute('PricingPageSectionFaq'),
            },
            {
              path: 'feature-icons',
              lazy: () => lazyAdminRoute('PricingPageSectionFeatureIcons'),
            },
          ],
        },
      ],
    },
    // missing label will get added by deepMerge from default config
    // @ts-ignore
    menus: {
      config: {
        positions: [
          'drive-navbar',
          'drive-sidebar',
          'homepage-navbar',
          'shareable-link-page',
          'footer',
          'footer-secondary',
        ],
        availableRoutes: [
          '/',
          '/#features',
          '/#download',
          '/pricing',
          '/score',
          '/help',
          '/privacy-policy',
          '/drive',
          '/drive/shares',
          '/drive/recent',
          '/drive/starred',
          '/drive/trash',
        ],
      } as MenuSectionConfig,
    },
    // @ts-ignore
    'seo-settings': {
      config: {
        pages: [
          {
            key: 'landing-page',
            label: message('Landing page'),
          },
          {
            key: 'shareable-link-page',
            label: message('Shareable link page'),
          },
        ],
      } as SeoSettingsSectionConfig,
    },
  },
};
